/* 口袋精灵相关接口 */
import http from '@/utils/http-v4'
import config from '@/config/config'

const api = {
  getFairyList: `${config.apiv4Root}/inner4/ilisten/fairy:list`,
  getFairy: `${config.apiv4Root}/inner4/ilisten/fairy:get`,
  getDeviceList: `${config.apiv4Root}/inner4/ilisten/fairy/device:list`,
  bindDevice: `${config.apiv4Root}/inner4/ilisten/fairy:bind`,
  unbindDevice: `${config.apiv4Root}/inner4/ilisten/fairy:unbind`,
}

export async function getFairyList(page = 1, size = 10) {
  return http.get(api.getFairyList, {
    status: 1,
    limit: size,
    offset: (page - 1) * size
  })
}

export function getFairy(id) {
  return http.get(api.getFairy, { f_id: id })
}

export function getFairyDeviceList() {
  return http.get(api.getDeviceList)
}

export function bindDevice(id, code) {
  return http.post(api.bindDevice, {
    f_id: id,
    code
  })
}

export function unbindDevice(id, device) {
  return http.post(api.unbindDevice, {
    f_id: id,
    f_device: device
  })
}
